export default `<div>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style=" font-size:18pt; font-weight:bold">投保人声明及确认</span></p>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style=" font-size:10pt; font-weight:bold">&#xa0;</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">1. 本公司/单位兹申请“美亚和顺保互联网团体意外伤害保险”，并声明以上陈述及各项细节属真实无讹</span><span
        style=" font-size:10.5pt">。本公司/</span><span
        style=" font-size:10.5pt">单位同意，本投保申请将会构成投保人与美亚财产保险有限公司（以下简称“贵公司”）所签署的保险合同的依据。本公司/单位理解并同意，贵公司承担保险责任须经投保人缴付本合同</span><span
        style=" font-size:10.5pt">项下的约定保险费并经贵公司签发保险单确认承保后开始。 </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">2.
        本公司/单位确认：本公司/单位已经认真阅读保险合同规定，尤其是免除保险人责任的规定，并对贵公司就保险合同的内容说明和提示完全理解，没有异议，申请投保。 本公司/单位知晓所有保险责任均以保险合同所载为准。
    </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">3. 本公司/单位确认：本公司已获得各被保险人的各项同意（包括各被保险人对本保险项下身故保障投保事宜以及保险金额的同意）
        ，由本公司为其投保本团体保险；同时本公司/单位同意，如本公司在保险有效期内按约定解除保险合同的，将告知各被保险人。 </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">4.
        本公司/单位确认：本公司/单位已经认真阅读投保须知中所列的所有投保条件，并如实告知所有投保前提条件；本公司/单位同意，在订立保险合同过程中如未如实填写本投保申请或未如实告知被保险人的有关情况（包括但不限于投保条件的确认），应视为本公司/单位故意未依法履行如实告知义务，由此可能导致该投保无效或贵公司不承担保险责任。
    </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">5. 本公司/单位同意凡申请投保的员工资料或之后的变更资料，均视为本投保申请的一部分，也是贵公司核保的基础。 </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">6.
        本公司/单位明白：本公司/单位作为投保人具有支付保险费义务，本公司/单位原则上应通过本公司/单位账户支付保险费，在本公司/单位账户无法支付的情况下将授权本公司/单位员工代为支付保险费。  </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">7.
        本公司/单位明白：于订立保险合同或因履行保险合同发生争议时，本公司与贵公司协商解决。协商不成的，本公司与贵公司协商一致选择以诉讼或仲裁的方式，解决于订立保险合同或因履行保险合同时发生的争议。 </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">8. 本公司/单位确认已阅读并理解贵公司在官网发布的隐私政策</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">（https://www.aig.com.cn/individuals/privacy-notice），同意向所有被保险人获得符合《中华人民共和国个人信息保护法》下规定的各项有效同意，以便贵公司根据该隐私政策，处理（包括不限于收集、使用、向境内外第三方提供）被保险人的个人信息以及被保险人所提供的其他个人的个人信息（该信息无论是从投保单还是其他地方获得），以实现下列各项目的：(1)处理本投保申请或其他与保险相关的事宜，如承保、理赔；(2)提供与本保险有关的服务；(3)与本公司/单位和/或被保险人沟通；(4)贵公司或贵公司所属集团内的关联公司进行业务分析、管理；(5)利用贵公司所属集团公司内的网络为本公司/单位和/或被保险人提供更全面的其它保险服务；(6)遵守所有适用于贵公司的法律法规和监管要求；及(7)前述隐私政策中“我们使用个人信息的目的”项下所述的其它目的。本公司/单位同时同意，贵公司可按照前述目的处理本公司/单位的其他信息。</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">9. 此外，本公司/单位同意，从被保险人处获得的前述有效同意包括就所有下述情形的单独同意： </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">(1)
        贵公司根据隐私政策中“我们使用个人信息的目的”项下所述的目的处理个人信息，这些信息可能含有贵公司隐私政策中“我们收集并持有的个人信息”项下所述的敏感个人信息。《中华人民共和国个人信息保护法》规定，敏感个人信息包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹、不满十四周岁未成年人的个人信息；</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">(2)</span><span
        style="width:5.25pt; text-indent:0pt; display:inline-block"></span><span
        style=" font-size:10.5pt">贵公司将个人信息披露或提供给贵公司隐私政策中“个人信息的分享方”项下所述的第三方；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">(3)</span><span
        style="width:5.25pt; text-indent:0pt; display:inline-block"></span><span
        style=" font-size:10.5pt">贵公司根据贵公司隐私政策中“个人信息处理地点”项下所述在中国境外处理个人信息，并将个人信息提供给隐私政策中“个人信息的分享方”项下所述中国境外的接收方。
    </span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">10.
        如果本公司/单位提供了其他个人的个人信息，我们确认已向其他个人提供了贵公司的隐私政策，并获得了其就贵公司根据隐私政策处理个人信息的有效同意。所述同意包括在处理其个人敏感信息、向第三方披露其个人信息、向中国境外接收方提供其个人信息以及在中国境外处理其个人信息方面的单独同意。</span>
</p>
</div>`